<template>
  <div class="w-50 pr-12px">
    <div class="half-graph-container">
      <div
        class="
          d-flex
          justify-content-start
          align-items-center
          border-bottom
          px-2
          pb-2
        "
      >
        <div class="dashboardAdmin-cards-head ml-2">Third Party Usage</div>
      </div>

      <div
        style="margin: auto"
        v-if="thirdPartySpinner"
        class="d-flex justify-content-center align-items-center h-100"
      >
        <b-spinner label="Loading..."></b-spinner>
      </div>

      <div
        v-else-if="!thirdPartySpinner && !noThirdPartyData"
        class="d-flex h-90"
      >
        <div style="width: 80%" class="h-100">
          <div id="horizontal_barGraph" style="width: 100%; height: 100%"></div>
        </div>
        <div
          style="width: 20%"
          class="h-100 d-flex align-items-end justify-content-end"
        >
          <div class="legend-container">
            <div
              class="d-flex align-items-center"
              v-for="(data, i) in thirdPartyData"
              :key="i + 'thirdP'"
            >
              <div
                class="legend-color-circle mr-1"
                :style="{ backgroundColor: data.colourCode }"
              ></div>
              <div class="legend-heading">{{ data.name }}</div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else-if="!thirdPartySpinner && noThirdPartyData"
        class="d-flex align-items-center justify-content-center w-100 h-100"
      >
        <img src="../../assets/ReportsNew/thirdPartyNodata.svg" alt="" />
      </div>
      <!-- <div class="d-flex align-items-center justify-content-center h-90">
        <div
          v-if="noThirdPartyData"
          class="d-flex align-items-center justify-content-center w-100"
        >
          <img src="../../assets/ReportsNew/thirdPartyNodata.svg" alt="" />
        </div>  
      </div> -->
      <!-- <div
          v-if="noThirdPartyData"
          class="d-flex align-items-center justify-content-center w-100"
        >
          <img src="../../assets/ReportsNew/thirdPartyNodata.svg" alt="" />
        </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { thirdPartyUsage } from "../../utils/apiFunctions";
import { thirdPartyBar } from "vue-d3-charts-hire3x";

export default {
  props: {
    leadKey: Boolean,
  },
  data() {
    return {
      thirdPartySpinner: true,
      thirdPartyData: [],
      noThirdPartyData: true,
      n: 5,
    };
  },
  computed: {
    ...mapGetters("userVUEX", {
      roleValues: "getRoleValues",
    }),
  },
  created() {
    this.getThirdPartyUasge();
  },
  methods: {
    areAllCountsZero(data, property) {
      // Check if all specified properties are zero
      return data.every((item) => item[property] === 0);
    },

    async getThirdPartyUasge() {
      try {
        const payload = {
          userID: this.roleValues.userID,
          lead: this.leadKey,
        };
        const response = await thirdPartyUsage(payload);
        if (response.status == 200) {
          this.thirdPartyData = response.data.data.data;
          const width = 700;
          const height = 290;
          const textXaxis = "No.of Usage";

          const clr = ["#F5D06E", "#595959", "#4070EA", "#269C8A"];
          // this.thirdPartyData = [
          // {
          //       "key": "microsoftTeams",
          //       "name": "Microsoft Teams",
          //       "count": 25
          //   },
          //   {
          //       "key": "Google",
          //       "name": "Alphabets Google",
          //       "count": 15
          //   },
          //   {
          //       "key": "Amazon",
          //       "name": "Amazon tc",
          //       "count": 2
          //   },
          //   { "key": "amcf", "name": "akjbhjo ", "count": 0 },
          // ]

          this.thirdPartyData = this.thirdPartyData.map((d, i) => {
            return {
              ...d,
              colourCode: clr[i],
            };
          });

          // console.log(this.areAllCountsZero(this.thirdPartyData,"count"),"HERREEE YOU GO ")
          if (this.thirdPartyData.length > 0) {
            this.noThirdPartyData = this.areAllCountsZero(
              this.thirdPartyData,
              "count"
            );
            setTimeout(() => {
              if (
                document.getElementById("horizontal_barGraph").innerHTML != ""
              ) {
                document.getElementById("horizontal_barGraph").innerHTML = "";
              }
              let e = new thirdPartyBar();
              e.horizontalBarGraph(
                this.thirdPartyData,
                "#horizontal_barGraph",
                width,
                height,
                textXaxis
              );
            }, 200);
          }
        } else {
          this.noThirdPartyData = true;
        }
      } catch (error) {
        console.error(error);
      }
      this.thirdPartySpinner = false;
    },
  },
};
</script>

<style lang="postcss" scoped></style>
